<a href="https://x.com/quizzaro"
    ><span><img src="../../../assets/image/twitter.png" alt="twitter icon" srcset="" /></span
></a>
